
window.addEventListener('load', event => {
    const stageSiteMapPanels = document.querySelectorAll('.stage-sitemap-panel');

    for ( const stageSiteMapPanel of stageSiteMapPanels ) {
        const lotSortChangeButton = stageSiteMapPanel.querySelectorAll('#lotSortChange');
        const lotSortReverseButton = stageSiteMapPanel.querySelectorAll('#lotSortReverse');
        const lotSelector = stageSiteMapPanel.querySelectorAll('.lot-selector');
        const lotTcs = stageSiteMapPanel.querySelector('#lot-selector-tcs');
        const lotSelectorAnchor = stageSiteMapPanel.querySelector('#lotSelector');
        const siteHeader = document.getElementById('siteHeader');

        if (lotSortChangeButton.length) {
            lotSortChangeButton.forEach((element) => {
                element.addEventListener('click', function (event) {
                    lotSortChange(element);
                })
            })
        }

        if (lotSortReverseButton.length) {
            lotSortReverseButton.forEach((element) => {
                element.addEventListener('click', function (event) {
                    lotSortReverse(element);
                })
            })
        }

        if (lotSelector.length) {
            lotSelector.forEach((element) => {
                element.addEventListener('change', function (event) {
                    lotUpdateSelected(element);
                    if (lotTcs) {
                        if (lotTcs.classList.contains('hidden')) {
                            lotTcs.classList.remove('hidden');
                        }
                    }
                    if (lotSelectorAnchor) {
                        let scrollOptions = { behavior: 'smooth' };

                        if (siteHeader) {
                            const headerHeight = siteHeader.offsetHeight;
                            const offset = headerHeight + parseFloat(getComputedStyle(document.documentElement).fontSize);
                            scrollOptions.block = 'start';
                            window.scrollBy({ top: lotSelectorAnchor.getBoundingClientRect().top - offset, behavior: 'smooth' });
                        } else {
                            lotSelectorAnchor.scrollIntoView(scrollOptions);
                        }
                    }
                })
            })
        }
    }
});


// Updates visible Lot Card to match selected value
// Updates hidden field on form for Lot Number
function lotUpdateSelected(element) {
    let selectedLot = element.value;
    const containerEle = element.closest('.stage-sitemap-panel ');
    const lotInfo = containerEle.querySelectorAll('.lot-info-cards');
    const selectors = containerEle.querySelectorAll('select');
    const forms = containerEle.querySelectorAll('form');

    selectors.forEach((selector) => {
        selector.value = selectedLot;
    })
    if (lotInfo.length) {
        lotInfo.forEach((lotDataContainer) => {
            if (lotDataContainer.dataset.lot === selectedLot) {
                lotDataContainer.classList.remove('hidden');
            } else {
                lotDataContainer.classList.add('hidden');
            }
        });
    }
    if (forms.length) {
        forms.forEach((form) => {
            let lotNumberField = form.querySelector('input[name=lotNumber]');
            if (lotNumberField) {
                lotNumberField.value = selectedLot;
            }
        });
    }
}

// Switches visible select field to one with a different sort method
function lotSortChange(element) {
    const containerEle = element.closest('.stage-sitemap-panel ');
    const selectors = containerEle.querySelectorAll('select');

    if (element.dataset.activeSort === 'sortedLotsAlphabet') {
        element.querySelector('span').innerHTML = "Sort by lot area";
        element.dataset.activeSort = 'sortedLotsArea'
        selectors.forEach((selector) => {
            if (selector.dataset.filter === 'sortedLotsAlphabet') {
                selector.classList.add('hidden');
            } else if (selector.dataset.filter === 'sortedLotsArea') {
                selector.classList.remove('hidden');
            }
            selector.selectedIndex = 0;
        })
    } else if (element.dataset.activeSort === 'sortedLotsArea') {
        element.querySelector('span').innerHTML = "Sort by lot frontage";
        element.dataset.activeSort = 'sortedLotsFrontage'
        selectors.forEach((selector) => {
            if (selector.dataset.filter === 'sortedLotsArea') {
                selector.classList.add('hidden');
            } else if (selector.dataset.filter === 'sortedLotsFrontage') {
                selector.classList.remove('hidden');
            }
            selector.selectedIndex = 0;
        })
    } else if (element.dataset.activeSort === 'sortedLotsFrontage') {
        element.querySelector('span').innerHTML = "Sort by lot #";
        element.dataset.activeSort = 'sortedLotsAlphabet'
        selectors.forEach((selector) => {
            if (selector.dataset.filter === 'sortedLotsFrontage') {
                selector.classList.add('hidden');
            } else if (selector.dataset.filter === 'sortedLotsAlphabet') {
                selector.classList.remove('hidden');
            }
            selector.selectedIndex = 0;
        })
    }
}

// Reverses option order in all select fields - commented code would allow the selected option to persist
function lotSortReverse(element) {
    const icon = element.querySelector('.icon');
    const iconChild = icon.querySelectorAll('div');
    iconChild.forEach((child) => {
        if (child.classList.contains('w-4')) {
            child.classList.remove('w-4')
            child.classList.add('w-2')
        } else if  (child.classList.contains('w-2')) {
            child.classList.remove('w-2')
            child.classList.add('w-4')
        }
    })
    if (element.querySelector('span').innerHTML !== element.querySelector('span').dataset.descending) {
        element.querySelector('span').innerHTML = element.querySelector('span').dataset.descending;
    } else {
        element.querySelector('span').innerHTML = element.querySelector('span').dataset.ascending;
    }
    const containerEle = element.closest('.stage-sitemap-panel');
    const selectors = containerEle.querySelectorAll('select');
    selectors.forEach((selector) => {
        let wasSelected = selector.selectedIndex;
        for (var i = 1; i < selector.childNodes.length; i++){
            selector.insertBefore(selector.childNodes[i], selector.firstChild);
        };
        if (wasSelected.value === 'placeholder') {
            selector.selectedIndex = 0;
        }
        for (let option of selector) {
            if(option.value === 'placeholder') {
                selector.prepend(option)
            }
        }
    });
}